module.exports = __webpack_public_path__ + "static/media/D_12_L.22bc1499.png";